// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__0NyhO","container__outlet":"dashboard_container__outlet__UaxtV","container__outlet__box":"dashboard_container__outlet__box__sFnHM"};